<template>
    <teleport to="#modal">
        <Loading :visible="loading">
        </Loading>
    </teleport>
    <div class="m-auto px-8 md:px-20 pb-8">
        <div class="max-w-screen-2xl m-auto pt-5">
            <div class="flex justify-between">

                <h2 class="text-3xl font-bold mb-4">{{ title[tab] }}: {{ bi_data?.nodo }}</h2>

                <Switcher v-model:model-value="tab" :options="title"></Switcher>
            </div>

            <div v-show="tab == 0"
                class="grid grid-cols-[repeat(2,_minmax(0,_1fr))_100px] gap-3 auto-rows-[1fr] grid-flow-row">

                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Costi da ordine:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <p class="text-right"><b>{{
                        $filters.toEuroCurrency(Number(bi_data?.costi_preventivo_ordine_pos))
                            }}</b></p>
                </div>
                <NextButton component="router-link" class="p-2"
                    :to="{ name: 'CostiPreventivo', params: { id }, query: { segno: 1 } }">Dettaglio
                </NextButton>


                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Totale ordini di nota credito:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <b>{{ $filters.toEuroCurrency(Number(bi_data?.costi_preventivo_ordine_neg)) }}</b>
                </div>
                <NextButton component="router-link" class="p-2"
                    :to="{ name: 'CostiPreventivo', params: { id }, query: { segno: -1 } }">Dettaglio
                </NextButton>


                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Costi BSP:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <b>{{ $filters.toEuroCurrency(Number(bi_data?.costi_preventivo_bsp)) }}</b>
                </div>
                <NextButton component="router-link" class="p-2"
                    :to="{ name: 'CostiBiglietteriaAerea', params: { id } }">
                    Dettaglio
                </NextButton>

                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Costi PICO:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <b>{{ $filters.toEuroCurrency(Number(bi_data?.costi_preventivo_pico)) }}</b>
                </div>
                <NextButton component="router-link" class="p-2"
                    :to="{ name: 'CostiBiglietteriaFerroviaria', params: { id } }">Dettaglio
                </NextButton>


                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Costi carte:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <b>{{ $filters.toEuroCurrency(Number(bi_data?.costi_preventivo_carte_di_Credito)) }}</b>
                </div>
                <NextButton component="router-link" class="p-2" :to="{ name: 'CostiCarte', params: { id } }">
                    Dettaglio
                </NextButton>


                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Costi note spesa:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <b>{{ $filters.toEuroCurrency(Number(bi_data?.costi_preventivo_note_spese)) }}</b>
                </div>
                <NextButton component="router-link" class="p-2" :to="{ name: 'CostiNoteSpesa', params: { id } }">
                    Dettaglio
                </NextButton>


                <div class="px-2 whitespace-nowrap text-sm justify-end flex items-center font-bold">Totale costi:</div>
                <div class="px-2 whitespace-nowrap text-sm relative bg-next-gray-md-dark flex items-center justify-end">
                    <b>{{ $filters.toEuroCurrency(Number(bi_data?.costi_preventivo)) }}</b>
                </div>
                <div></div>


                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Ordini di vendita:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <b>{{ $filters.toEuroCurrency(Number(bi_data?.ricavi_preventivo_pos)) }}</b>
                </div>
                <NextButton component="router-link" class="p-2"
                    :to="{ name: 'RicaviPreventivo', params: { id }, query: { segno: 1 } }">
                    Dettaglio
                </NextButton>

                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Ordini di vendita nota credito:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <b>{{ $filters.toEuroCurrency(Number(bi_data?.ricavi_preventivo_neg)) }}</b>
                </div>
                <NextButton component="router-link" class="p-2"
                    :to="{ name: 'RicaviPreventivo', params: { id }, query: { segno: -1 } }">
                    Dettaglio
                </NextButton>


                <div class="px-2 whitespace-nowrap text-sm justify-end flex items-center font-bold">Totale vendita:
                </div>
                <div class="px-2 whitespace-nowrap text-sm relative bg-next-gray-md-dark flex items-center justify-end">
                    <b>{{ $filters.toEuroCurrency(Number(bi_data?.ricavi_preventivo)) }}</b>
                </div>
                <div></div>


                <div class="px-2 whitespace-nowrap text-sm justify-end flex items-center font-bold">Primo margine lordo
                    74TER:
                </div>
                <div class="px-2 whitespace-nowrap text-sm relative bg-next-gray-md-dark flex items-center justify-end">
                    <b>{{
                        $filters.toEuroCurrency(Number(bi_data?.primo_margine_preventivo) + Number(bi_data?.iva_74TER))
                        }}</b>
                </div>
                <div></div>


                <div class="px-2 whitespace-nowrap text-sm justify-end flex items-center font-bold">Primo margine:</div>
                <div class="px-2 whitespace-nowrap text-sm relative bg-next-gray-md-dark flex items-center justify-end">
                    <b>{{ $filters.toEuroCurrency(Number(bi_data?.primo_margine_preventivo)) }}</b>
                </div>
                <div></div>

                <template v-if="dividiPersonale">

                    <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Costo personale esterno:</div>
                    <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                        <b>{{
                            $filters.toEuroCurrency(Number(bi_data?.costi_contratti))
                        }}</b>
                    </div>
                    <div></div>

                    <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Costo aziendale timesheet:</div>
                    <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                        <b>{{
                            $filters.toEuroCurrency(Number(bi_data?.costi_timesheet_proporzionato))
                        }}</b>
                    </div>
                    <div></div>
                </template>
                <template v-else>
                    <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Costo personale:</div>
                    <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                        <b>{{
                            $filters.toEuroCurrency(Number(bi_data?.costi_timesheet_proporzionato) +
                                Number(bi_data?.costi_contratti))
                        }}</b>
                    </div>
                    <div></div>
                </template>

                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Costi finanziari:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <b>{{ $filters.toEuroCurrency(-Number(bi_data?.oneri_finanziari)) }}</b>
                </div>
                <NextButton component="router-link" class="p-2" :to="{ name: 'CostiFinanziari', params: { id } }">
                    Dettaglio
                </NextButton>


                <div class="px-2 whitespace-nowrap text-sm justify-end flex items-center font-bold">Secondo margine:
                </div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <b>{{
                        $filters.toEuroCurrency(
                            Number(bi_data?.primo_margine_preventivo) -
                            Number(bi_data?.costi_timesheet_proporzionato) +
                            Number(bi_data?.oneri_finanziari) -
                            Number(bi_data?.costi_contratti))
                    }}</b>
                </div>
                <div></div>
            </div>

            <div v-show="tab == 1"
                class="grid grid-cols-[repeat(2,_minmax(0,_1fr))_100px_50px_1fr] gap-3 auto-rows-[1fr] grid-flow-row">
                <h3 class="col-span-5 font-bold">Attivo</h3>

                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Preventivo:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <p class="text-right"><b>{{
                        $filters.toEuroCurrency(Number(bi_data?.ricavi_preventivo_gamma))
                            }}</b></p>
                </div>
                <div></div>
                <div class="row-span-5 grid grid-cols-2 grid-rows-8 py-5">
                    <span class="border-black border-t border-r rounded-tr-lg">-</span>
                    <span class="border-black border-b"></span>
                    <span class="border-black border-r border-b rounded-br-lg">+</span>
                    <span></span>
                    <span class="border-black border-t border-r rounded-tr-lg">-</span>
                    <span></span>
                    <span class="border-black border-r border-b">+</span>
                    <span class="border-black border-b"></span>
                    <span class="border-black border-r"></span>
                    <span></span>
                    <span class="border-black border-r border-b rounded-br-lg">+</span>
                </div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end translate-y-6">
                    <p class="text-right"><b>{{
                        $filters.toEuroCurrency(Number(bi_data?.ricavi_preventivo) - Number(bi_data?.ricavi_preventivo_gamma))
                            }}</b></p>
                </div>

                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Ordine:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <p class="text-right"><b>{{
                        $filters.toEuroCurrency(Number(bi_data?.ricavi_preventivo))
                            }}</b></p>
                </div>
                <NextButton class="p-2" @click="tab = 0">Dettaglio</NextButton>
                <div></div>

                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Fatture cliente:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <p class="text-right"><b>{{
                        $filters.toEuroCurrency(Number(bi_data?.fatture_cliente))
                            }}</b></p>
                </div>
                <NextButton component="router-link" class="p-2"
                    :to="{ name: 'FattureCliente', params: { id }, query: { nc: 0 } }">
                    Dettaglio
                </NextButton>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <p class="text-right"><b>{{
                        $filters.toEuroCurrency(Number(bi_data?.fatture_cliente) + Number(bi_data?.fatture_cliente_NC) - Number(bi_data?.ricavi_preventivo))
                            }}</b></p>
                </div>

                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Fatture cliente NC:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <p class="text-right"><b>{{
                        $filters.toEuroCurrency(Number(bi_data?.fatture_cliente_NC))
                            }}</b></p>
                </div>
                <NextButton component="router-link" class="p-2"
                    :to="{ name: 'FattureCliente', params: { id }, query: { nc: 1 } }">
                    Dettaglio
                </NextButton>
                <div></div>

                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Incassi:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <p class="text-right"><b>{{
                        $filters.toEuroCurrency(Number(bi_data?.incassato))
                            }}</b></p>
                </div>
                <NextButton component="router-link" class="p-2"
                    :to="{ name: 'IncassiPagamenti', params: { id }, query: { incassi: 1 } }">Dettaglio
                </NextButton>
                <div></div>

                <h3 class="col-span-5 font-bold">Passivo</h3>

                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Preventivo:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <p class="text-right"><b>{{
                        $filters.toEuroCurrency(Number(bi_data?.costi_preventivo_gamma))
                            }}</b></p>
                </div>
                <div></div>
                <div class="row-span-5 grid grid-cols-2 grid-rows-8 py-5">
                    <span class="border-black border-t border-r rounded-tr-lg">-</span>
                    <span class="border-black border-b"></span>
                    <span class="border-black border-r border-b rounded-br-lg">+</span>
                    <span></span>
                    <span class="border-black border-t border-r rounded-tr-lg">-</span>
                    <span></span>
                    <span class="border-black border-r border-b">+</span>
                    <span class="border-black border-b"></span>
                    <span class="border-black border-r"></span>
                    <span></span>
                    <span class="border-black border-r border-b rounded-br-lg">+</span>
                </div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end translate-y-6">
                    <p class="text-right"><b>{{
                        $filters.toEuroCurrency(Number(bi_data?.costi_preventivo) - Number(bi_data?.costi_preventivo_gamma))
                            }}</b></p>
                </div>

                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Ordine:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <p class="text-right"><b>{{
                        $filters.toEuroCurrency(Number(bi_data?.costi_preventivo))
                            }}</b></p>
                </div>
                <NextButton class="p-2" @click="tab = 0">Dettaglio</NextButton>
                <div></div>

                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Fatture fornitore:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <p class="text-right"><b>{{
                        $filters.toEuroCurrency(Number(bi_data?.fatture_fornitore))
                            }}</b></p>
                </div>
                <NextButton component="router-link" class="p-2"
                    :to="{ name: 'FattureFornitore', params: { id }, query: { nc: 0 } }">Dettaglio
                </NextButton>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <p class="text-right"><b>{{
                        $filters.toEuroCurrency(Number(bi_data?.fatture_fornitore) + Number(bi_data?.fatture_fornitore_NC) - Number(bi_data?.costi_preventivo))
                            }}</b></p>
                </div>

                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Fatture fornitore NC:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <p class="text-right"><b>{{
                        $filters.toEuroCurrency(Number(bi_data?.fatture_fornitore_NC))
                            }}</b></p>
                </div>
                <NextButton component="router-link" class="p-2"
                    :to="{ name: 'FattureCliente', params: { id }, query: { nc: 1 } }">
                    Dettaglio
                </NextButton>
                <div></div>

                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark">Pagamenti:</div>
                <div class="px-2 flex items-center text-sm bg-next-gray-md-dark justify-end">
                    <p class="text-right"><b>{{
                        $filters.toEuroCurrency(Number(bi_data?.pagato))
                            }}</b></p>
                </div>
                <NextButton component="router-link" class="p-2"
                    :to="{ name: 'IncassiPagamenti', params: { id }, query: { incassi: 0 } }">Dettaglio
                </NextButton>
                <div></div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, setup, Vue } from 'vue-class-component';
import sottoProgettiManager from "@/api/SottoProgetti";
import Loading from "@/components/Loading.vue";
import NextButton from "@/components/NextButton.vue";
import MenuButton from "@/components/MenuButton.vue";
import Switcher from "@/components/Switcher.vue";
import businessUnitsManager from "@/api/BusinessUnits";

@Options({
    name: 'CostiRicaviSottoProgetto',
    components: { Switcher, Loading, MenuButton, NextButton },
    props: {
        id: [Number, String],
    },
    computed: {},
    methods: {}
})
export default class CostiRicaviSottoProgetto extends Vue {
    id!: string;
    bi_data: any = null;
    loading = false;
    tab = 0;
    title = [
        'Costi e ricavi',
        // 'Incassi e pagamenti'
    ]
    sottoprogetto:any = {};

    created() {
        this.loading = true;
        sottoProgettiManager.sottoprogetto(this.id).then((response: any) => {
            this.sottoprogetto = response.data;
            businessUnitsManager.businessUnit(this.sottoprogetto.business_unit_id).then((response: any) => {
                this.sottoprogetto.business_unit = response.data;
            });
        });
        sottoProgettiManager.costiRicavi(this.id).then((response: any) => {
            this.bi_data = response.data;
        }).finally(() => {
            this.loading = false;
        });
    }

    get dividiPersonale() {
        switch (this.sottoprogetto?.business_unit?.label) {
            case 'EV':
            case 'AD':
                return true;
            default:
                return false;
        }
    }
}

</script>


<style lang="scss" scoped></style>
